/* ============================================================
   LAYALI — Nuit Magique · theme.js
   Panier natif Shopify (AJAX API) + drawer + upsell + animations
   GSAP/ScrollTrigger/Lenis chargés avant ce script (defer).
   ============================================================ */

(() => {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const eur = (cents) =>
    new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    }).format(cents / 100);

  const imgTaille = (url, w) =>
    url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  /* ========================================================
     PANIER — API AJAX Shopify (/cart.js, /cart/add.js, /cart/change.js)
     ======================================================== */

  let panier = null;

  async function chargerPanier() {
    try {
      panier = await (await fetch('/cart.js')).json();
    } catch {
      panier = { items: [], item_count: 0, total_price: 0 };
    }
    rendrePanier();
    majBadge();
  }

  async function ajouterAuPanier(variantId, opts = {}) {
    let r;
    try {
      r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: opts.qty || 1 }),
      });
    } catch {
      toast('Connexion impossible — réessaie');
      return false;
    }
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      toast(err.description || 'Stock insuffisant pour cet article');
      await chargerPanier();
      ouvrirPanier();
      return false;
    }
    await chargerPanier();
    majBadge(true);
    if (opts.flyFrom) volVersPanier(opts.flyFrom);
    if (!opts.silencieux) toast(opts.message || 'Ajouté au panier');
    if (!opts.sansOuverture) setTimeout(ouvrirPanier, opts.flyFrom ? 750 : 350);
    return true;
  }

  async function changerLigne(cle, qty, ligneEl) {
    ligneEl?.classList.add('maj');
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cle, quantity: qty }),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        toast(err.description || 'Quantité indisponible');
        ligneEl?.classList.remove('maj');
        await chargerPanier();
        return;
      }
      panier = await r.json();
    } catch {
      toast('Connexion impossible — réessaie');
    }
    rendrePanier();
    majBadge();
  }

  function majBadge(pop = false) {
    const badge = $('[data-badge-panier]');
    if (!badge || !panier) return;
    badge.textContent = panier.item_count;
    badge.classList.toggle('visible', panier.item_count > 0);
    if (pop && panier.item_count > 0) {
      badge.classList.remove('pop');
      void badge.offsetWidth;
      badge.classList.add('pop');
    }
  }

  /* ---------- Rendu du drawer ---------- */

  function ligneHTML(item) {
    const detail = item.variant_title
      ? `Pointure ${item.variant_title}`
      : '';
    return `
      <div class="ligne-panier" data-cle="${item.key}">
        <img src="${imgTaille(item.image, 200)}" alt="" loading="lazy" width="96" height="110">
        <div>
          <h4>${item.product_title}</h4>
          <p class="details">${detail ? detail + ' · ' : ''}${eur(item.final_price)}</p>
          <div class="ligne-bas">
            <div class="stepper">
              <button type="button" data-moins aria-label="Réduire la quantité">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-plus aria-label="Augmenter la quantité">+</button>
            </div>
            <span class="ligne-prix">${eur(item.final_line_price)}</span>
          </div>
          <button type="button" class="suppr-ligne" data-suppr>Retirer</button>
        </div>
      </div>`;
  }

  const HANDLES_TALONS = ['peridot', 'rubellite', 'opale', 'lazuli', 'sans-titre-13juil-_19-20-03'];

  function rendrePanier() {
    const corps = $('#panier-corps');
    const pied = $('#panier-pied');
    if (!corps || !panier) return;

    if (!panier.items.length) {
      corps.innerHTML = `
        <div class="panier-vide">
          <p>Ton panier attend sa première nuit magique.</p>
          <a class="btn btn-plein" href="${corps.dataset.urlCollection || '/collections/all'}">Découvrir la collection</a>
        </div>`;
      if (pied) pied.style.display = 'none';
      return;
    }

    corps.innerHTML = panier.items.map(ligneHTML).join('');

    /* bag offert : ≥ 2 paires de talons → bandeau cadeau */
    const nbPaires = panier.items
      .filter((i) => HANDLES_TALONS.includes(i.handle))
      .reduce((s, i) => s + i.quantity, 0);
    const aBag = panier.items.some((i) => i.handle === 'bag');
    const gabaritBag = $('#gabarit-bag-offert');

    if (nbPaires >= 2 && gabaritBag) {
      const blocBag = gabaritBag.content.cloneNode(true);
      const wrapper = $('.bag-offert', blocBag);
      if (wrapper) {
        if (aBag) {
          const btn = $('[data-bag-ajout]', blocBag);
          if (btn) { btn.textContent = 'Ajouté ✦'; btn.classList.add('ajoute'); btn.disabled = true; }
          $('h5', wrapper).textContent = 'Ton BAG est offert ✦';
          const p = $('p', wrapper);
          if (p) p.textContent = 'Merci pour ta confiance — il est dans ton panier.';
        }
        corps.appendChild(blocBag);
      }
    }

    /* upsell : gabarit Liquid cloné, cartes filtrées selon le panier */
    const gabarit = $('#gabarit-upsell');
    if (gabarit) {
      const bloc = gabarit.content.cloneNode(true);
      const handles = panier.items.map((i) => i.handle);
      let visibles = 0;
      $$('.upsell-carte', bloc).forEach((carte) => {
        if (handles.includes(carte.dataset.upsellHandle)) carte.remove();
        else visibles++;
      });
      if (visibles > 0) corps.appendChild(bloc);
    }

    if (pied) pied.style.display = '';
    const total = $('#panier-total');
    if (total) total.textContent = eur(panier.total_price);

    /* interactions */
    $$('.ligne-panier', corps).forEach((el) => {
      const cle = el.dataset.cle;
      const item = panier.items.find((i) => i.key === cle);
      if (!item) return;
      $('[data-plus]', el)?.addEventListener('click', () => changerLigne(cle, item.quantity + 1, el));
      $('[data-moins]', el)?.addEventListener('click', () => changerLigne(cle, item.quantity - 1, el));
      $('[data-suppr]', el)?.addEventListener('click', () => changerLigne(cle, 0, el));
    });

    $$('[data-upsell-ajout]', corps).forEach((btn) => {
      btn.addEventListener('click', () => {
        const carte = btn.closest('.upsell-carte');
        btn.textContent = 'Ajouté ✦';
        btn.classList.add('ajoute');
        ajouterAuPanier(carte.dataset.variantId, { silencieux: true, sansOuverture: true });
      });
    });

    /* bag offert : bouton ajouter */
    const btnBag = $('[data-bag-ajout]:not([disabled])', corps);
    if (btnBag) {
      btnBag.addEventListener('click', () => {
        const wrapper = btnBag.closest('.bag-offert');
        btnBag.textContent = 'Ajouté ✦';
        btnBag.classList.add('ajoute');
        btnBag.disabled = true;
        ajouterAuPanier(wrapper.dataset.bagVariant, { silencieux: true, sansOuverture: true, message: 'BAG offert ajouté ✦' });
      });
    }
  }

  /* ---------- Drawer ---------- */

  function ouvrirPanier() {
    document.body.classList.add('panier-ouvert');
    $('.panier')?.setAttribute('aria-hidden', 'false');
    if (window.gsap && !reduit) {
      window.gsap.fromTo(
        '.panier .ligne-panier, .panier .panier-upsell',
        { opacity: 0, y: 18 },
        { opacity: 1, y: 0, duration: 0.5, stagger: 0.06, ease: 'power3.out', delay: 0.15, clearProps: 'all' }
      );
    }
  }

  function fermerPanier() {
    document.body.classList.remove('panier-ouvert');
    $('.panier')?.setAttribute('aria-hidden', 'true');
  }

  /* ---------- Toast + vol vers le panier ---------- */

  let toastTimer;
  function toast(message) {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.innerHTML = `<i>✦</i> ${message}`;
    requestAnimationFrame(() => el.classList.add('visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('visible'), 2600);
  }

  function volVersPanier(imgSource) {
    const cible = $('.btn-panier');
    if (!cible || !window.gsap || reduit || !imgSource) return;
    const r1 = imgSource.getBoundingClientRect();
    const r2 = cible.getBoundingClientRect();
    const clone = document.createElement('img');
    clone.src = imgSource.currentSrc || imgSource.src;
    clone.className = 'vol-panier';
    clone.style.left = `${r1.left + r1.width / 2 - 40}px`;
    clone.style.top = `${r1.top + r1.height / 2 - 40}px`;
    document.body.appendChild(clone);
    window.gsap.to(clone, {
      left: r2.left + r2.width / 2 - 40,
      top: r2.top + r2.height / 2 - 40,
      scale: 0.12,
      opacity: 0.4,
      duration: 0.75,
      ease: 'power3.inOut',
      onComplete: () => clone.remove(),
    });
  }

  /* ========================================================
     PAGE PRODUIT
     ======================================================== */

  function initProduit() {
    const form = $('[data-form-produit]');
    if (!form) return;

    /* galerie */
    const images = $$('[data-image-galerie]');
    $$('[data-vignette]').forEach((v) => {
      v.addEventListener('click', () => {
        const i = +v.dataset.index;
        images.forEach((img) => img.classList.toggle('active', +img.dataset.index === i));
        $$('[data-vignette]').forEach((x) => x.classList.toggle('active', x === v));
      });
    });

    /* pointures */
    const note = $('.stock-note');
    const prixFiche = $('[data-prix-fiche]');
    $$('input[data-taille]', form).forEach((radio) => {
      radio.addEventListener('change', () => {
        const qte = +radio.dataset.qty;
        if (note) note.textContent = qte === 1 ? '✦ Dernière paire disponible dans cette pointure' : '';
        if (prixFiche && radio.dataset.prix) prixFiche.textContent = radio.dataset.prix;
      });
    });

    /* soumission */
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const champ = form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
      const btn = $('[data-btn-ajout]', form);
      if (!champ || !champ.value) {
        if (note) note.textContent = '✦ Choisis d’abord ta pointure';
        const choix = $('.choix-taille', form);
        if (window.gsap && choix) {
          window.gsap.fromTo(choix, { x: -7 }, { x: 0, duration: 0.5, ease: 'elastic.out(1, 0.3)' });
        }
        choix?.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      const visuel = $('.galerie-principale img.active') || $('.galerie-principale img');
      const texteInitial = btn.textContent;
      ajouterAuPanier(champ.value, { flyFrom: visuel, silencieux: true }).then((ok) => {
        if (!ok) return;
        btn.classList.add('ajoute');
        btn.textContent = 'Ajouté au panier ✦';
        setTimeout(() => {
          btn.classList.remove('ajoute');
          btn.textContent = texteInitial;
        }, 2400);
      });
    });

    /* cross-sell */
    $$('[data-complement-ajout]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const visuel = btn.closest('.carte-complement')?.querySelector('img');
        btn.textContent = 'Ajouté ✦';
        btn.classList.add('ajoute');
        ajouterAuPanier(btn.dataset.variantId, { flyFrom: visuel, silencieux: true });
        setTimeout(() => {
          btn.textContent = 'Ajouter';
          btn.classList.remove('ajoute');
        }, 2400);
      });
    });
  }

  /* ========================================================
     AJOUTS RAPIDES (accueil : bag, huile)
     ======================================================== */

  function initAjoutsRapides() {
    $$('[data-ajout-rapide]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const visuel = btn.closest('section')?.querySelector('img');
        ajouterAuPanier(btn.dataset.variantId, { flyFrom: visuel });
      });
    });
  }

  /* ========================================================
     HEADER + MENU MOBILE
     ======================================================== */

  function initHeader() {
    const header = $('[data-header]');
    if (!header) return;
    const heroSombre = header.dataset.heroSombre === 'true';
    if (heroSombre) {
      const bascule = () => header.classList.toggle('solide', window.scrollY > 60);
      bascule();
      addEventListener('scroll', bascule, { passive: true });
    }
    $('[data-burger]')?.addEventListener('click', () => document.body.classList.toggle('menu-ouvert'));
    $$('[data-menu-mobile] a').forEach((a) =>
      a.addEventListener('click', () => document.body.classList.remove('menu-ouvert'))
    );
  }

  /* ========================================================
     ANIMATIONS (voile, hero, reveals, parallax, magnétisme)
     ======================================================== */

  function initVoile() {
    const voile = document.getElementById('voile');
    if (!voile) return;
    if (sessionStorage.getItem('layali-voile')) {
      voile.style.display = 'none';
      document.body.classList.add('pret', 'voile-fini');
      return;
    }
    sessionStorage.setItem('layali-voile', '1');
    setTimeout(() => {
      document.body.classList.add('pret');
      setTimeout(() => document.body.classList.add('voile-fini'), 1000);
    }, 1350);
  }

  function initAnimations() {
    const { gsap } = window;
    if (!gsap || reduit) {
      $$('[data-reveal]').forEach((el) => (el.style.opacity = 1));
      document.body.classList.add('pret');
      setTimeout(() => document.body.classList.add('voile-fini'), 50);
      const voile = document.getElementById('voile');
      if (voile) voile.style.display = 'none';
      return;
    }

    gsap.registerPlugin(window.ScrollTrigger);

    /* Lenis : jamais en contexte automatisé ni si ?sansfluide */
    const sansFluide =
      new URLSearchParams(location.search).has('sansfluide') || navigator.webdriver;
    if (window.Lenis && !sansFluide && matchMedia('(hover: hover)').matches) {
      const lenis = new window.Lenis({ lerp: 0.095, wheelMultiplier: 0.95 });
      lenis.on('scroll', window.ScrollTrigger.update);
      gsap.ticker.add((t) => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href*="#"]');
        if (!a) return;
        const url = new URL(a.href, location.href);
        if (url.pathname !== location.pathname || !url.hash) return;
        const cible = document.querySelector(url.hash);
        if (!cible) return;
        e.preventDefault();
        lenis.scrollTo(cible, { offset: -70, duration: 1.4 });
      });
    }

    /* hero */
    const titre = $('.hero-titre');
    if (titre) {
      const premierPassage = document.getElementById('voile')?.style.display !== 'none';
      const tl = gsap.timeline({ delay: premierPassage ? 1.15 : 0.15, defaults: { ease: 'power4.out' } });
      tl.from('.hero-eyebrow', { opacity: 0, y: 18, duration: 0.8 })
        .from('.hero-titre .ligne > span', { yPercent: 115, duration: 1.15, stagger: 0.09 }, '-=0.5')
        .from('.hero-sous', { opacity: 0, y: 24, duration: 0.9 }, '-=0.55')
        .from('.hero-cta > *', { opacity: 0, y: 18, duration: 0.7, stagger: 0.08 }, '-=0.6')
        .from('.hero-cadre', { clipPath: 'inset(8% 8% 8% 8% round 45% 45% 1rem 1rem)', opacity: 0, scale: 0.96, duration: 1.3, ease: 'power3.inOut' }, 0.25)
        .from('.hero-cadre img', { scale: 1.28, duration: 1.6, ease: 'power3.out' }, 0.3)
        .from('.hero-pastille', { scale: 0, rotate: -60, duration: 0.9, ease: 'back.out(1.6)' }, '-=0.9')
        .from('.hero-scroll', { opacity: 0, duration: 0.8 }, '-=0.4');
    }

    /* reveals */
    $$('[data-reveal]:not([data-reveal-groupe] [data-reveal])').forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 42 },
        { opacity: 1, y: 0, duration: 1.05, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 86%', once: true } }
      );
    });
    $$('[data-reveal-groupe]').forEach((groupe) => {
      gsap.fromTo(
        $$('[data-reveal]', groupe),
        { opacity: 0, y: 48 },
        { opacity: 1, y: 0, duration: 1.05, stagger: 0.11, ease: 'power3.out', scrollTrigger: { trigger: groupe, start: 'top 82%', once: true } }
      );
    });

    /* dézoom éditorial */
    $$('[data-zoom] img').forEach((img) => {
      gsap.fromTo(
        img,
        { scale: 1.22 },
        { scale: 1.06, ease: 'none', scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: 1.2 } }
      );
    });

    /* parallax */
    $$('[data-parallax]').forEach((el) => {
      const force = parseFloat(el.dataset.parallax) || 60;
      gsap.fromTo(
        el,
        { y: force * 0.6 },
        { y: -force, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 1.4 } }
      );
    });

    /* magnétisme boutons */
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      $$('.btn').forEach((btn) => {
        const xTo = gsap.quickTo(btn, 'x', { duration: 0.4, ease: 'power3' });
        const yTo = gsap.quickTo(btn, 'y', { duration: 0.4, ease: 'power3' });
        btn.addEventListener('pointermove', (e) => {
          const r = btn.getBoundingClientRect();
          xTo(((e.clientX - r.left) / r.width - 0.5) * 10);
          yTo(((e.clientY - r.top) / r.height - 0.5) * 8);
        });
        btn.addEventListener('pointerleave', () => {
          xTo(0);
          yTo(0);
        });
      });
    }
  }

  /* ========================================================
     DÉMARRAGE
     ======================================================== */

  function init() {
    initVoile();
    initHeader();
    initProduit();
    initAjoutsRapides();

    $$('[data-ouvre-panier]').forEach((b) =>
      b.addEventListener('click', () => {
        document.body.classList.contains('panier-ouvert') ? fermerPanier() : ouvrirPanier();
      })
    );
    $$('[data-ferme-panier]').forEach((b) => b.addEventListener('click', fermerPanier));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') fermerPanier();
    });

    chargerPanier();
    initAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
